module.exports = __webpack_public_path__ + "img/ebook_page.e2d53bd5.png";